import {
    SystemState,
    SystemActionTypes,
  } from './types'

export const initialState: SystemState = {
    clipLength: [10, 300],
    fullScreen: true,
    playVideoOnce: false,
    randomBlackouts: false,
    audioOnly: false
}

export default (state:SystemState = initialState, action: SystemActionTypes) : SystemState => {

    switch (action.type) {
        case '@@system/SET_CLIP_LENGTH':
            state.clipLength = action.payload.clipLength
            return state 
        case '@@system/SET_FULLSCREEN':
            state.fullScreen = action.payload.isFullscreen
            return state 
        case '@@system/TOGGLE_FULLSCREEN':
            state.fullScreen = !state.fullScreen
            return state
        case '@@system/TOGGLE_PLAY_VIDEOS_ONCE':
            state.playVideoOnce = !state.playVideoOnce
            return state
        case '@@system/TOGGLE_RANDOM_BLACKOUTS':
            state.randomBlackouts = !state.randomBlackouts
            return state
        case '@@system/TOGGLE_AUDIO_ONLY':
            state.audioOnly = !state.audioOnly
            return state
        default:
            return state
    }
}
